import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { FormInstance } from 'antd'
import { State } from '../../types/StateType'
import { Doctor } from './types'

const doctorAdapter = createEntityAdapter<Doctor>({
  selectId: (doctor) => doctor.doctorKey,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = doctorAdapter.getInitialState(definedProps)

const doctorSlice = createSlice({
  name: 'doctor',
  initialState: initialState,
  reducers: {
    getDoctor: (state, action: PayloadAction<string>) => {
      state.loading = true
    },
    getDoctors: (state) => {
      state.loading = true
    },
    addDoctors: (state, action: PayloadAction<Doctor[]>) => {
      state.loading = false
      doctorAdapter.upsertMany(state, action.payload)
    },
    addDoctor: (state, action: PayloadAction<Doctor>) => {},
    addDoctorSuccess: (state, action: PayloadAction<Doctor>) => {
      state.loading = false
      doctorAdapter.addOne(state, action.payload)
    },
    setDoctorForUpdate: (
      state,
      action: PayloadAction<{
        form: FormInstance<any>
        key: string
      }>
    ) => {},
    setDoctorForUpdateSuccess: (
      state,
      action: PayloadAction<{
        form: FormInstance<any>
        doctorData: Doctor
      }>
    ) => {
      action.payload.form.setFieldsValue({
        ...action.payload.doctorData,
      })
    },
    activateDoctor: (state, action: PayloadAction<string>) => {},
    changeDoctorRole: (
      state,
      action: PayloadAction<{
        id: string
        role: string
      }>
    ) => {},
    deleteDoctor: (state, action: PayloadAction<string>) => {},
    deleteDoctorSuccess: (state, action: PayloadAction<string>) => {
      state.loading = false
      const patientIdToDelete = action.payload
      doctorAdapter.removeOne(state, patientIdToDelete)
    },
    updateDoctor: (state, action: PayloadAction<Doctor>) => {},
    updateDoctorSuccess: (state, action: PayloadAction<Doctor>) => {
      state.loading = false
      doctorAdapter.upsertOne(state, action.payload)
    },
    updateDoctorKey: (state, action: PayloadAction<Doctor>) => {
      state.loading = false
      doctorAdapter.upsertOne(state, action.payload)
    },
    errorDoctor: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    successDoctor: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload
    },
  },
})

export const {
  errorDoctor,
  getDoctor,
  getDoctors,
  addDoctor,
  addDoctorSuccess,
  updateDoctor,
  updateDoctorSuccess,
  deleteDoctor,
  deleteDoctorSuccess,
  updateDoctorKey,
  addDoctors,
  activateDoctor,
  changeDoctorRole,
  successDoctor,
  setDoctorForUpdate,
  setDoctorForUpdateSuccess,
} = doctorSlice.actions

export default doctorSlice.reducer

const { selectById: selectByKey } = doctorAdapter.getSelectors()

export const selectAllDoctors = createSelector(
  (state: State) => state.doctorState,
  (doctors) => Object.values(doctors['entities'])
)

export const selectDoctorByKey = (doctorKey: string) =>
  createSelector(
    (state: State) => state.doctorState,
    (doctors) => selectByKey(doctors, doctorKey)
  )

export const selectErrorInDoctor = createSelector(
  (state: State) => state.doctorState.error,
  (error) => error
)
export const selectSuccessInDoctor = createSelector(
  (state: State) => state.doctorState.success,
  (success) => success
)
export const selectDoctorLoadingState  = createSelector(
  (state: State) => state.doctorState.loading,
  (success) => success
)